<template>
  <v-app class="weather-app">
    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-weather-partly-cloudy </v-icon>
          </div>

          <div>
            <div class="header-info-title">Perubahan cuaca per jam</div>
            <div class="header-info-subtitle">{{ currentAddress }}</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="main-container">
        <div class="content-wrapper">
          <section class="weather-intro">
            <div class="intro-left">
              <div class="intro-icon">
                <v-icon size="30" color="#018c74">mdi-weather-partly-cloudy</v-icon>
              </div>

              <div class="intro-copy">
                <div class="intro-eyebrow">INFO CUACA LOKAL</div>
                <h1>Cuaca di sekitar Anda</h1>
                <p>
                  Lihat kondisi cuaca sekarang dan perkiraan beberapa jam ke depan. Pilih
                  desa untuk melihat informasi yang sesuai dengan wilayah Anda.
                </p>
              </div>
            </div>

            <div class="intro-search">
              <div class="section-label">WILAYAH ANDA</div>
              <div class="section-title">Pilih desa atau kecamatan</div>

              <v-autocomplete
                v-model="selectedBps"
                :items="listBps"
                :filter="customFilter"
                item-text="desa"
                return-object
                placeholder="Ketik nama desa atau kecamatan..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                solo
                flat
                class="modern-search"
                :loading="loading"
                @change="onLocationChange"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title class="commodity-name">
                      {{ data.item.desa }}
                    </v-list-item-title>

                    <v-list-item-subtitle class="commodity-category">
                      {{ data.item.nama_kecamatan }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </div>
          </section>

          <div class="detail-panel">
            <div v-if="currentWeather" class="weather-grid">
              <div class="weather-left">
                <div class="weather-top">
                  <div class="weather-icon-block">
                    <v-icon size="70" color="#018c74">{{
                      getWeatherIcon(currentWeather.weather_desc)
                    }}</v-icon>
                  </div>

                  <div class="detail-title-area">
                    <div class="detail-badge">
                      <v-icon x-small>mdi-weather-partly-cloudy</v-icon>
                      CUACA SEKARANG
                    </div>

                    <h2 class="detail-title">{{ currentWeather.temp }}°C</h2>

                    <p class="detail-subtitle">{{ currentWeather.weather_desc }}</p>
                  </div>
                </div>

                <div class="detail-date-card">
                  <div class="date-icon">
                    <v-icon>mdi-clock-outline</v-icon>
                  </div>

                  <div>
                    <div class="date-label">WAKTU DATA CUACA</div>
                    <div class="date-value">{{ lastUpdate }}</div>
                  </div>
                </div>

                <div class="weather-stat-grid">
                  <div class="weather-stat">
                    <v-icon size="20" color="#018c74">mdi-water-percent</v-icon>
                    <div>
                      <div class="stat-label">KELEMBAPAN</div>
                      <div class="stat-value">{{ currentWeather.humidity }}%</div>
                    </div>
                  </div>

                  <div class="weather-stat">
                    <v-icon size="20" color="#018c74">mdi-weather-windy</v-icon>
                    <div>
                      <div class="stat-label">KECEPATAN ANGIN</div>
                      <div class="stat-value">{{ currentWeather.wind_speed }} km/j</div>
                    </div>
                  </div>

                  <div class="weather-stat">
                    <v-icon size="20" color="#018c74">mdi-compass-outline</v-icon>
                    <div>
                      <div class="stat-label">ARAH ANGIN</div>
                      <div class="stat-value">{{ currentWeather.wind_dir }}</div>
                    </div>
                  </div>

                  <div class="weather-stat">
                    <v-icon size="20" color="#018c74">mdi-database-outline</v-icon>
                    <div>
                      <div class="stat-label">SUMBER DATA</div>
                      <div class="stat-value">BMKG</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="weather-map-col">
                <div id="map" class="map-container"></div>

                <div class="radar-label">
                  <v-icon x-small class="mr-1">mdi-map-marker</v-icon>Lokasi desa yang
                  dipilih
                </div>
              </div>
            </div>

            <div v-else-if="weatherError" class="weather-message weather-message-error">
              <v-icon size="34" color="#B45309">mdi-cloud-alert-outline</v-icon>
              <div class="message-title">Cuaca belum tersedia</div>
              <p>{{ weatherError }}</p>
              <v-btn
                small
                depressed
                color="#018c74"
                dark
                :loading="loading"
                @click="fetchWeatherData"
              >
                <v-icon left small>mdi-refresh</v-icon>Coba lagi
              </v-btn>
            </div>

            <div v-else class="weather-message">
              <v-progress-circular
                indeterminate
                color="#018c74"
                size="32"
              ></v-progress-circular>
              <div>
                <div class="message-title">Sedang mengambil data cuaca</div>
                <p>Tunggu sebentar, informasi wilayah sedang disiapkan.</p>
              </div>
            </div>
          </div>

          <div class="section-heading">
            <div>
              <div class="section-label">PERKIRAAN BERIKUTNYA</div>
              <div class="section-title">Perubahan cuaca per jam</div>
            </div>
          </div>

          <div class="forecast-hourly-scroll">
            <div
              v-for="(hour, i) in hourlyData"
              :key="i"
              :class="['hour-item', isNightTime(hour.time) ? 'night-box' : 'day-box']"
            >
              <div class="hour-date">{{ hour.date }}</div>
              <div class="hour-time">{{ hour.time }}</div>

              <v-icon :color="isNightTime(hour.time) ? '#ffffff' : '#018c74'">{{
                hour.icon
              }}</v-icon>

              <div class="hour-temp">{{ hour.temp }}°C</div>
              <div class="hour-status">{{ hour.status }}</div>

              <div class="hour-hum">
                <v-icon x-small class="mr-1">mdi-water</v-icon>{{ hour.hum }}%
              </div>
            </div>
          </div>

          <div class="page-footer">
            <div>BONDOWOSO BERKAH</div>
            <span></span>
            <div>INFORMASI CUACA WILAYAH</div>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getDesa } from "@/api/androidInitApi";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

export default {
  name: "CuacaDesa",

  data: () => ({
    currentAddress: "Memuat data wilayah...",
    selectedBps: null,
    listBps: [],
    loading: false,
    weatherError: "",
    lastUpdate: "",
    currentWeather: null,
    hourlyData: [],
  }),

  created() {
    this.map = null;
    this.marker = null;
  },

  mounted() {
    this.fetchMasterData();
  },

  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
      this.marker = null;
    }
  },

  methods: {
    customFilter(item, queryText) {
      const textKec = item.nama_kecamatan.toLowerCase();
      const textDesa = item.desa.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textKec.indexOf(searchText) > -1 || textDesa.indexOf(searchText) > -1;
    },

    initMap() {
      this.$nextTick(() => {
        if (!this.map && document.getElementById("map")) {
          this.map = L.map("map", {
            zoomControl: true,
            attributionControl: false,
          }).setView([-7.9135, 113.8217], 13);

          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
          }).addTo(this.map);
        }
      });
    },

    updateMapLocation(lat, lon) {
      if (!this.map) {
        this.initMap();
        setTimeout(() => this.updateMapLocation(lat, lon), 500);
        return;
      }

      const coords = [lat, lon];

      this.map.invalidateSize();
      this.map.setView(coords, 15);

      if (this.marker) {
        this.marker.setLatLng(coords);
      } else {
        this.marker = L.marker(coords).addTo(this.map);
      }
    },

    async fetchMasterData() {
      try {
        this.listBps = (await getDesa()) || [];

        const defaultLoc = this.listBps.find((item) =>
          item.desa?.toUpperCase().includes("SUCOLOR")
        );

        this.selectedBps = defaultLoc || this.listBps[0];

        this.fetchWeatherData();
      } catch (e) {
        console.error("Gagal Muat Master", e);
      }
    },

    onLocationChange() {
      this.fetchWeatherData();
    },

    async fetchWeatherData() {
      if (!this.selectedBps) return;

      this.loading = true;
      this.weatherError = "";

      try {
        const res = await axios.get(
          `https://api.bmkg.go.id/publik/prakiraan-cuaca?adm4=${this.selectedBps.kode_bps}`
        );

        const lokasi = res.data.data[0].lokasi;

        if (lokasi && lokasi.lat) {
          this.updateMapLocation(lokasi.lat, lokasi.lon);
        }

        const allData = res.data.data[0].cuaca.flat();

        const sortedCuaca = allData.sort(
          (a, b) => new Date(a.datetime) - new Date(b.datetime)
        );

        const nowLocal = new Date();

        const displayData = sortedCuaca.filter((item) => {
          return (
            new Date(item.local_datetime) >=
            new Date(nowLocal.getTime() - 2 * 60 * 60 * 1000)
          );
        });

        this.currentAddress = `Desa ${this.selectedBps.desa}, ${this.selectedBps.nama_kecamatan}`;

        const current = displayData[0];

        this.currentWeather = {
          temp: current.t,
          weather_desc: current.weather_desc,
          wind_speed: current.ws,
          wind_dir: current.wd,
          humidity: current.hu,
        };

        this.lastUpdate =
          new Date(current.local_datetime).toLocaleTimeString("id-ID", {
            hour: "2-digit",
            minute: "2-digit",
          }) + " WIB";

        this.hourlyData = displayData.slice(0, 12).map((item) => {
          const dt = new Date(item.local_datetime);

          return {
            time: dt
              .toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" })
              .replace(".", ":"),
            date: dt.toLocaleDateString("id-ID", { day: "numeric", month: "short" }),
            temp: item.t,
            status: item.weather_desc,
            hum: item.hu,
            icon: this.getWeatherIcon(item.weather_desc),
          };
        });
      } catch (error) {
        console.error(error);
        this.weatherError =
          "Data cuaca untuk wilayah ini belum dapat dimuat. Periksa koneksi internet Anda lalu coba lagi.";
      } finally {
        this.loading = false;
      }
    },

    getWeatherIcon(desc) {
      if (!desc) return "mdi-cloud";

      const s = desc.toLowerCase();

      if (s.includes("petir")) return "mdi-weather-lightning";
      if (s.includes("hujan")) return "mdi-weather-pouring";
      if (s.includes("cerah")) return "mdi-weather-sunny";
      if (s.includes("berawan")) return "mdi-cloud";

      return "mdi-cloud-outline";
    },

    isNightTime(timeStr) {
      const hr = parseInt(timeStr.split(":")[0]);

      return hr >= 18 || hr <= 5;
    },
  },
};
</script>

<style scoped>
.weather-app {
  --teal: #018c74;
  --teal-dark: #006b5b;
  --teal-soft: #e8f5f2;
  --gold: #f3a928;
  --gold-soft: #fff5df;
  --text: #1d2935;
  --text-soft: #6e7b87;
  --border: rgba(20, 75, 70, 0.1);
  --gap: 16px;

  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.main-container {
  position: relative;
  z-index: 5;
  padding: 24px 24px 32px !important;
}

.content-wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.weather-intro {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
  align-items: center;
  gap: 28px;
  margin-bottom: var(--gap);
  padding: 22px 26px;
  border: 1px solid rgba(1, 140, 116, 0.1);
  border-radius: 22px;
  background: linear-gradient(115deg, #e8f7f2 0%, #ffffff 72%);
  box-shadow: 0 12px 34px rgba(30, 70, 65, 0.045);
}

.intro-left {
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 0;
}

.intro-icon {
  width: 62px;
  height: 62px;
  flex: 0 0 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 5px 16px rgba(1, 140, 116, 0.09);
}

.intro-eyebrow {
  color: var(--teal);
  font-size: 0.68rem;
  font-weight: 900;
  letter-spacing: 1.2px;
  margin-bottom: 4px;
}

.intro-copy h1 {
  margin: 0 0 6px;
  color: var(--text);
  font-size: clamp(1.25rem, 2.4vw, 1.75rem);
  line-height: 1.25;
  font-weight: 850;
}

.intro-copy p {
  margin: 0;
  max-width: 560px;
  color: #647580;
  font-size: 0.86rem;
  line-height: 1.6;
}

.intro-search {
  min-width: 0;
}

.section-label {
  color: var(--gold);
  font-size: 0.64rem;
  font-weight: 900;
  letter-spacing: 1.5px;
}

.section-title {
  margin: 2px 0 10px;
  color: var(--text);
  font-size: 1.15rem;
  font-weight: 900;
  line-height: 1.35;
}

.modern-search {
  width: 100%;
}

.modern-search::v-deep .v-input__slot {
  min-height: 52px !important;
  margin-bottom: 0 !important;
  padding: 0 15px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(1, 140, 116, 0.14);
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(30, 70, 65, 0.05) !important;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.modern-search::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;
  border-color: rgba(1, 140, 116, 0.4);
}

.modern-search::v-deep .v-icon {
  color: var(--teal) !important;
}

.modern-search::v-deep input {
  color: var(--text) !important;
  font-size: 0.85rem !important;
}

.modern-search::v-deep input::placeholder {
  color: #8b969f !important;
}

.commodity-name {
  color: var(--text);
  font-size: 0.82rem;
  font-weight: 800;
}

.commodity-category {
  color: var(--text-soft) !important;
  font-size: 0.68rem;
}

.detail-panel {
  margin-bottom: 20px;
  padding: 20px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--border);
  border-radius: 24px;
  box-shadow: 0 18px 60px rgba(30, 70, 65, 0.08);
}

.weather-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  gap: 20px;
  align-items: stretch;
}

.weather-left {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

.weather-top {
  display: flex;
  align-items: center;
  gap: 18px;
}

.weather-icon-block {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 112px;
  flex-shrink: 0;
  border-radius: 24px;
  background: var(--teal-soft);
}

.detail-title-area {
  min-width: 0;
}

.detail-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border-radius: 7px;
  color: var(--teal);
  background: var(--teal-soft);
  font-size: 0.61rem;
  font-weight: 900;
  letter-spacing: 1px;
}

.detail-title {
  margin: 8px 0 2px;
  color: var(--text);
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 900;
  line-height: 1.1;
}

.detail-subtitle {
  margin: 0;
  color: var(--text-soft);
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.4;
}

.detail-date-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 13px;
  border-radius: 13px;
  background: #fafcfc;
  border: 1px solid rgba(1, 140, 116, 0.1);
}

.date-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  color: var(--gold);
  background: var(--gold-soft);
}

.date-label {
  color: var(--text-soft);
  font-size: 0.55rem;
  font-weight: 900;
  letter-spacing: 1px;
}

.date-value {
  margin-top: 2px;
  color: var(--text);
  font-size: 0.78rem;
  font-weight: 800;
}

.weather-stat-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.weather-stat {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 12px 14px;
  border-radius: 13px;
  background: #fafcfc;
  border: 1px solid var(--border);
}

.weather-stat .v-icon {
  flex-shrink: 0;
}

.stat-label {
  color: var(--text-soft);
  font-size: 0.58rem;
  font-weight: 900;
  letter-spacing: 0.4px;
}

.stat-value {
  margin-top: 3px;
  color: var(--text);
  font-size: 0.9rem;
  font-weight: 800;
}

.weather-map-col {
  position: relative;
  min-height: 320px;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(30, 70, 65, 0.06);
}

.map-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.radar-label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  padding: 7px 8px;
  background: rgba(255, 255, 255, 0.94);
  color: var(--text);
  font-size: 0.62rem;
  font-weight: 800;
  text-align: center;
  border-top: 1px solid var(--border);
  pointer-events: none;
}

.weather-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 160px;
  padding: 24px;
  text-align: left;
}

.weather-message-error {
  flex-direction: column;
  text-align: center;
}

.message-title {
  color: var(--text);
  font-weight: 800;
  font-size: 1rem;
}

.weather-message p {
  margin: 4px 0 12px;
  max-width: 440px;
  color: var(--text-soft);
  font-size: 0.84rem;
  line-height: 1.6;
}

.section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 4px;
}

.section-heading .section-title {
  margin-bottom: 8px;
}

.forecast-hourly-scroll {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  padding: 4px 2px 8px;
}

.hour-item {
  padding: 14px 10px;
  border-radius: 16px;
  text-align: center;
  color: var(--text);
  box-shadow: 0 8px 24px rgba(30, 70, 65, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hour-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(1, 140, 116, 0.14);
}

.day-box {
  background: #ffffff;
  border: 1px solid var(--border);
}

.night-box {
  background: linear-gradient(160deg, var(--teal-dark), var(--teal));
  border: 1px solid var(--teal-dark);
  color: #ffffff;
}

.hour-date {
  color: var(--gold);
  font-size: 0.56rem;
  font-weight: 900;
  letter-spacing: 0.6px;
}

.hour-time {
  margin-top: 2px;
  font-size: 0.78rem;
  font-weight: 800;
}

.hour-temp {
  margin: 6px 0 2px;
  font-size: 1.1rem;
  font-weight: 900;
}

.hour-status {
  min-height: 28px;
  font-size: 0.58rem;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: 0.3px;
  opacity: 0.85;
  overflow-wrap: anywhere;
}

.hour-hum {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
}

.page-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
  color: #94a0a7;
  font-size: 0.57rem;
  font-weight: 800;
  letter-spacing: 1px;
}

.page-footer span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--gold);
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;
  backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;
  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;
  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);
  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f1faf8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;
  font-size: 10px;
  color: #929da1;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 960px) {
  .main-container {
    padding: 20px 16px 28px !important;
  }

  .weather-intro {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    padding: 20px;
  }

  .intro-copy p {
    max-width: none;
  }

  .detail-panel {
    padding: 16px;
  }

  .weather-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }

  .weather-map-col {
    min-height: 260px;
  }

  .forecast-hourly-scroll {
    display: flex;
    overflow-x: auto;
    padding-bottom: 14px;
    scrollbar-width: thin;
  }

  .hour-item {
    min-width: 104px;
    flex-shrink: 0;
  }

  .forecast-hourly-scroll::-webkit-scrollbar {
    height: 5px;
  }

  .forecast-hourly-scroll::-webkit-scrollbar-track {
    background: #f4f6f6;
  }

  .forecast-hourly-scroll::-webkit-scrollbar-thumb {
    background: rgba(1, 140, 116, 0.3);
    border-radius: 10px;
  }
}

@media (max-width: 600px) {
  .main-container {
    padding: 14px 10px 24px !important;
  }

  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }

  .weather-intro {
    padding: 16px 14px;
    border-radius: 17px;
  }

  .intro-left {
    align-items: flex-start;
    gap: 12px;
  }

  .intro-icon {
    width: 44px;
    height: 44px;
    flex-basis: 44px;
    border-radius: 13px;
  }

  .intro-copy p {
    font-size: 0.78rem;
    line-height: 1.55;
  }

  .section-title {
    font-size: 1.05rem;
  }

  .modern-search::v-deep .v-input__slot {
    min-height: 46px !important;
    padding: 0 11px !important;
    border-radius: 13px !important;
  }

  .modern-search::v-deep input {
    font-size: 0.75rem !important;
  }

  .detail-panel {
    padding: 14px;
    border-radius: 19px;
  }

  .weather-top {
    gap: 14px;
  }

  .weather-icon-block {
    width: 88px;
    height: 88px;
    border-radius: 20px;
  }

  .weather-icon-block .v-icon {
    font-size: 54px !important;
  }

  .detail-title {
    font-size: 2rem;
  }

  .weather-stat {
    padding: 10px 11px;
    gap: 8px;
  }

  .stat-value {
    font-size: 0.8rem;
  }

  .weather-map-col {
    min-height: 220px;
  }

  .hour-item {
    min-width: 92px;
    padding: 12px 9px;
  }

  .page-footer {
    margin-top: 12px;
    font-size: 0.48rem;
    gap: 7px;
  }
}
</style>
